import type { Game } from '@/types'

export function formatPrice(cents: number, currency: string): string {
  if (cents === 0) return 'Free'
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(cents / 100)
}

interface PriceTagProps {
  game: Pick<Game, 'price' | 'sale' | 'currency'> & { released?: string }
  compact?: boolean
}

export function PriceTag({ game, compact = false }: PriceTagProps) {
  if (game.price === 0 && game.released === 'Coming soon') {
    return <span className="cg-price">TBA</span>
  }
  if (!game.sale) {
    return <span className="cg-price">{formatPrice(game.price, game.currency)}</span>
  }
  const pct = Math.round(((game.price - game.sale) / game.price) * 100)
  return (
    <div className={compact ? 'cg-price-block compact' : 'cg-price-block'}>
      <span className="cg-discount">−{pct}%</span>
      <div className="cg-price-stack">
        <span className="cg-price-old">{formatPrice(game.price, game.currency)}</span>
        <span className="cg-price-new">{formatPrice(game.sale, game.currency)}</span>
      </div>
    </div>
  )
}
